<template>
  <div class="company-info-page">
    <!-- 账号设置 -->
    <a-card title="认证中心" :bordered="false">
      <div class="ant-row-flex" style="margin: 18px 4px 14px">
        <a-space align="center">
          <div class="title_icon"></div>
          <div
            class="ant-descriptions-title"
            style="font-size: 14px; margin-bottom: 0px"
          >
            个人自助认证
          </div>
        </a-space>
      </div>
      <!-- 实名认证 -->
      <div class="setting-item">
        <div class="col-left">
          <template v-if="!spinning">
            <template v-if="certName && certNum"
              ><span class="status-dot blue"></span>
              <span class="left-title">已认证</span>
            </template>
            <template v-else
              ><span class="status-dot gray"></span>
              <span class="left-title">未认证</span>
            </template>
          </template>
          <a-spin v-else />
        </div>

        <div class="col-desc">实名认证</div>

        <div class="col-extra">保障账户安全，确认用户身份</div>

        <div class="col-action">
          <template v-if="!spinning">
            <a-button
              v-if="certName && certNum"
              type="primary"
              disabled
              size="small"
              >认证</a-button
            >
            <a-button
              v-else
              type="primary"
              size="small"
              @click="changeToCertVerify"
              >认证</a-button
            >
          </template>
          <a-spin v-else />
        </div>
      </div>

      <!-- 手机绑定 -->
      <div class="setting-item">
        <div class="col-left">
          <template v-if="!spinning">
            <template v-if="certName && certNum"
              ><span class="status-dot blue"></span>
              <span class="left-title">已认证</span>
            </template>
            <template v-else
              ><span class="status-dot gray"></span>
              <span class="left-title">未认证</span>
            </template>
          </template>
          <a-spin v-else />
        </div>

        <div class="col-desc">证件有效期</div>

        <div class="col-extra">
          证件有效期的截止日期
          <template v-if="!spinning">{{ certEffToDate }}</template>
        </div>
        <div class="col-action">
          <a-button type="primary" size="small" @click="changeToCertVerify"
            >更新</a-button
          >
        </div>
      </div>

      <div class="ant-row-flex" style="margin: 18px 4px 14px">
        <a-space align="center">
          <div class="title_icon"></div>
          <div
            class="ant-descriptions-title"
            style="font-size: 14px; margin-bottom: 0px"
          >
            企业自助认证
          </div>
        </a-space>
      </div>

      <div class="setting-item">
        <template v-if="!spinning">
          <template v-if="certName && certNum">
            <div class="col-left">
              <span class="status-dot gray"></span>
              <span class="left-title">已认证</span>
            </div>

            <div class="col-desc">企业认证</div>

            <div class="col-extra">以企业身份参与项目, 已认证1家企业</div>

            <div class="col-action">
              <a-button
                type="primary"
                size="small"
                @click="changeToCompanyVerify"
                >十 新增认证</a-button
              >
            </div>
          </template>
          <template v-else>
            <div class="col-left">

            </div>

            <div class="col-desc"></div>

            <div class="col-extra" style="color: red;">请先完成实名认证，完成实名认证后方可进行企业认证</div>

            <div class="col-action">
              <a-button
                type="primary"
                size="small"
                disabled
                @click="changeToCompanyVerify"
                >十 新增认证</a-button
              >
            </div>
          </template>
        </template>
        <a-spin v-else />
      </div>

      <div class="ant-row-flex" style="margin: 18px 4px 14px">
        <a-space align="center">
          <div class="title_icon"></div>
          <div
            class="ant-descriptions-title"
            style="font-size: 14px; margin-bottom: 0px"
          >
            企业认证列表
          </div>
        </a-space>
      </div>

      <a-table
        :pagination="tableCompany.pagination"
        :loading="tableCompany.loading"
        :columns="tableCompany.columns"
        :data-source="tableCompany.data"
        rowKey="id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{
            (tableCompany.pagination.pageNo - 1) *
              tableCompany.pagination.pageSize +
            index +
            1
          }}
        </span>
      </a-table>
    </a-card>
  </div>
</template>

<script>
// 企业台账表格列名
const columns = [
  {
    title: "序号",
    fixed: "left",
    width: 80,
    scopedSlots: { customRender: "index" },
  },
  {
    title: "企业名称",
    width: 500,
    dataIndex: "companyName",
  },
  {
    title: "法定代表人",
    width: 150,
    dataIndex: "legalPerson",
  },
  {
    title: "统一信用代码",
    width: 150,
    dataIndex: "certCode",
  },
];
import { personalInfo } from "@/api/user/personalCenter/PersonalCenter.js";
export default {
  data() {
    return {
      certName: undefined,
      certNum: undefined,
      certEffToDate: undefined,
      spinning: true,
      tableCompany: {
        columns,
        data: [
          // {
          //   companyName: "	上海新金山农商实业发展集团有限公司",
          //   legalPerson: "徐永华",
          //   certCode: "913101161342286419",
          // },
        ],
        pagination: {
          showTotal: (total) => `共 ${total} 条`,
        },
      },
    };
  },
  mounted() {
    personalInfo()
      .then((res) => {
        if (res && res.code === "200") {
          const result = res.data;
          this.certName = result.certName;
          this.certNum = result.certNum;
          this.certEffToDate = result.certEffToDate;
          this.spinning = !this.spinning;
        } else {
        }
      })
      .catch((err) => {
        console.error("接口调用异常：", err);
      });
  },
  methods: {
    changeToCompanyVerify() {
      this.$emit("changeToCompanyVerify");
    },
    changeToCertVerify() {
      this.$emit("changeToCertVerify");
    },
  },
};
</script>

<style scoped>
.company-info-page {
  padding: 8px;
}

/* 基本资料 */
.base-info {
  padding: 8px 16px;
  line-height: 32px;
  font-size: 14px;
}

.info-line .label {
  display: inline-block;
  width: 160px;
  font-weight: bold;
  color: #555;
}

/* 设置模块 */
.setting-item {
  display: grid;
  grid-template-columns: 180px 200px 1fr 100px;
  /* 左列、描述、中间值、按钮列 */
  align-items: center;
  padding: 14px 8px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}

.setting-item:last-child {
  border-bottom: none;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;
}

.status-dot.blue {
  background-color: #1890ff;
}

.status-dot.gray {
  background-color: #d9d9d9;
}

/* 左列：图标 + 标题 */
.col-left {
  display: flex;
  align-items: center;
}

.left-title {
  font-weight: 500;
}

/* 描述多行自动换行 */
.col-desc {
  color: #555;
}

/* 右侧附加字段 */
.col-extra {
  color: #888;
  padding-right: 12px;
}

/* 按钮 */
.col-action {
  text-align: right;
}

.title_icon {
  width: 4px;
  height: 26px;
  margin-right: 2px;
  background: #007aff;
}
</style>